<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title>
            <v-btn icon @click="$router.go(-1)">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>Verify
            <v-spacer></v-spacer>
            <v-text-field v-if="groupRequestedTab.open" v-model="groupRequestedTab.search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <v-text-field v-else-if="startWeightTab.open" v-model="startWeightTab.search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <v-text-field v-else v-model="endWeightTab.search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <v-progress-linear indeterminate color="yellow darken-2" v-if="loading"></v-progress-linear>
        </v-card-title>

        <!-- Dialog for confirm delete user -->
        <v-dialog v-model="dialogItem.deleteConfirmation" max-width="400px">
            <v-card>
                <v-card-title class="text">{{ dialogItem.confirmText }}</v-card-title>
                <v-card-actions v-if="dialogItem.confirmAction">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeConfirmationDialog">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                <v-card-actions v-else>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="actionDeleteGroup">Yes</v-btn>
                    <v-btn color="blue darken-1" text @click="closeConfirmationDialog">No</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-tabs>
            <v-tab @click="setActiveTab('groupRequestedTab')">{{groupRequestedTab.title}}</v-tab>
            <v-tab @click="setActiveTab('startWeightTab')">{{startWeightTab.title}}</v-tab>
            <v-tab @click="setActiveTab('endWeightTab')">{{endWeightTab.title}}</v-tab>

            <v-tab-item>
                <v-container fluid>
                    <!-- table listing -->
                    <v-data-table v-if="groupList.length" :headers="groupRequestedTab.headers" :items="groupList" :search="groupRequestedTab.search" sort-by="verifyInfo.verify" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="groupRequestedTab.options">
                        <template v-slot:[`item.verify`]="{ item }">
                            <v-switch v-if="item.verifyInfo.verify && item.verifyInfo.verifyDate" v-model="item.verifyInfo.verify" :input-value="item.verifyInfo.verify" @click="actionVerify(item)" color="primary" :label="_formatData('date', item.verifyInfo.verifyDate.toDate())"></v-switch>
                            <v-switch v-else v-model="item.verifyInfo.verify" :input-value="item.verifyInfo.verify" @click="actionVerify(item)" color="primary"></v-switch>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon class="mr-2" @click="dialogDeleteGroup(item)" title="Delete">
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                    <v-card-subtitle v-else>No item list</v-card-subtitle>
                </v-container>
            </v-tab-item>

            <v-tab-item>
                <v-container fluid>
                    <v-data-table v-if="userList.length" :headers="startWeightTab.headers" :items="userList" :search="startWeightTab.search" sort-by="verifyInfo.startWeightVerify" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="startWeightTab.options" :single-expand="startWeightTab.singleExpand" show-expand :expanded.sync="endWeightTab.expanded" item-key="uid">
                        <template v-slot:[`item.avatar`]="{ item }">
                            <v-avatar v-if="item.avatar" size="32" class="mr-2">
                                <img :src="item.avatar" />
                            </v-avatar>
                            <v-avatar v-if="!item.avatar" color="info" size="32" class="mr-2">
                                <v-icon dark> mdi-account-circle </v-icon>
                            </v-avatar>
                        </template>
                        <template v-slot:[`item.verify`]="{ item }">
                            <v-switch v-if="item.verifyInfo.startWeightVerify && item.verifyInfo.startWeightVerifyDate" v-model="item.verifyInfo.startWeightVerify" :input-value="item.verifyInfo.startWeightVerify" @click="actionVerify(item)" color="primary" :label="_formatData('date', item.verifyInfo.startWeightVerifyDate.toDate())"></v-switch>
                            <v-switch v-else v-model="item.verifyInfo.startWeightVerify" :input-value="item.verifyInfo.startWeightVerify" @click="actionVerify(item)" color="primary"></v-switch>
                        </template>
                        <template v-slot:expanded-item="{ item }"> 
                            <td :colspan="startWeightTab.headers.length" class="pa-6">
                                <v-container fluid>
                                    <v-row v-if="item.verifyInfo.startWeightImageUploadDate">
                                        <v-col>
                                            <v-card class="mx-auto" max-width="400">
                                                <v-card-subtitle class="pb-0 text-center">
                                                    Person image on {{ _formatData('date', item.verifyInfo.startWeightImageUploadDate.toDate())}}
                                                </v-card-subtitle>
                                                <v-img v-if="item.verifyInfo.startWeightPersonImage" class="white--text align-end" :src="item.verifyInfo.startWeightPersonImage">
                                                </v-img>
                                            </v-card>
                                        </v-col>
                                        <v-col>
                                            <v-card class="mx-auto" max-width="400">
                                                <v-card-subtitle class="pb-0 text-center">
                                                    Scale image on {{ _formatData('date', item.verifyInfo.startWeightImageUploadDate.toDate())}}
                                                </v-card-subtitle>
                                                <v-img v-if="item.verifyInfo.startWeightScaleImage" class="white--text align-end" :src="item.verifyInfo.startWeightScaleImage">
                                                </v-img>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    <v-row v-else>No image</v-row>
                                </v-container>
                            </td>
                        </template>
                    </v-data-table>
                    <v-card-subtitle v-else>No item list</v-card-subtitle>
                </v-container>
            </v-tab-item>

            <v-tab-item>
                <v-container fluid>
                    <v-data-table v-if="userList.length" :headers="endWeightTab.headers" :items="userList" :search="endWeightTab.search" sort-by="verifyInfo.endWeightVerify" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="endWeightTab.options" :single-expand="endWeightTab.singleExpand" show-expand :expanded.sync="endWeightTab.expanded" item-key="uid">
                        <template v-slot:[`item.avatar`]="{ item }">
                            <v-avatar v-if="item.avatar" size="32" class="mr-2">
                                <img :src="item.avatar" />
                            </v-avatar>
                            <v-avatar v-if="!item.avatar" color="info" size="32" class="mr-2">
                                <v-icon dark> mdi-account-circle </v-icon>
                            </v-avatar>
                        </template>
                        <template v-slot:[`item.verify`]="{ item }">
                            <v-switch v-if="item.verifyInfo.endWeightVerify && item.verifyInfo.endWeightVerifyDate" v-model="item.verifyInfo.endWeightVerify" :input-value="item.verifyInfo.endWeightVerify" @click="actionVerify(item)" color="primary" :label="_formatData('date', item.verifyInfo.endWeightVerifyDate.toDate())"></v-switch>
                            <v-switch v-else v-model="item.verifyInfo.endWeightVerify" :input-value="item.verifyInfo.endWeightVerify" @click="actionVerify(item)" color="primary"></v-switch>
                        </template>
                        <template v-slot:expanded-item="{ item }">
                            <td :colspan="endWeightTab.headers.length" class="pa-6">
                                <v-container fluid>
                                    <v-row v-if="item.verifyInfo.endWeightImageUploadDate">
                                        <v-col>
                                            <v-card class="mx-auto" max-width="400">
                                                <v-card-subtitle class="pb-0 text-center">
                                                    Person image on {{ _formatData('date', item.verifyInfo.endWeightImageUploadDate.toDate())}}
                                                </v-card-subtitle>
                                                <v-img v-if="item.verifyInfo.endWeightPersonImage" class="white--text align-end" :src="item.verifyInfo.endWeightPersonImage">
                                                </v-img>
                                            </v-card>
                                        </v-col>
                                        <v-col>
                                            <v-card class="mx-auto" max-width="400">
                                                <v-card-subtitle class="pb-0 text-center">
                                                    Scale image on {{ _formatData('date', item.verifyInfo.endWeightImageUploadDate.toDate())}}
                                                </v-card-subtitle>
                                                <v-img v-if="item.verifyInfo.endWeightScaleImage" class="white--text align-end" :src="item.verifyInfo.endWeightScaleImage">
                                                </v-img>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    <v-row v-else>No image</v-row>
                                </v-container>
                            </td>
                        </template>
                    </v-data-table>
                    <v-card-subtitle v-else>No item list</v-card-subtitle>
                </v-container>
            </v-tab-item>
        </v-tabs>
    </v-card>
</v-container>
</template>

<!-- startPersonImageUrl, startScaleImageUrl  startUploadDate -->

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData";
import getChallengeGroupListDetails from "../data/getChallengeGroupListDetails";
import getChallengeInfoById from "../data/getChallengeInfoById";
import setGroupInfo from "../data/setGroupInfo";
import removeChallengeGroup from "../data/removeChallengeGroup";
import getUserList from "../data/getUserList";
import setUserCompatitionInfo from "../data/setUserCompatitionInfo";

export default {
    name: 'ChallengeGroupVerify',
    metaInfo: {
        title: 'Challenge Group Verify'
    },
    data() {
        return {
            groupRequestedTab: {
                open: true,
                title: "Group",
                options: {
                    itemsPerPage: 20,
                },
                search: "",
                headers: [
                    {
                        text: "Group Id",
                        value: "id",
                    },
                    {
                        text: "Group Name",
                        value: "name",
                    },
                    {
                        text: "Admin Name",
                        value: "admin.name",
                    },
                    {
                        text: "Members",
                        value: "verifyInfo.members",
                    },
                    {
                        text: "Verify",
                        value: "verify",
                        sortable: false,
                    },
                    {
                        text: "Actions",
                        value: "actions",
                        sortable: false,
                    },
                ],
            },
            startWeightTab: {
                open: false,
                expanded: [],
                singleExpand: true,
                title: "Start",
                options: {
                    itemsPerPage: 20,
                },
                search: "",
                headers: [{
                        text: "",
                        value: "avatar",
                        sortable: false
                    }, {
                        text: "User Name",
                        value: "name",
                    }, {
                        text: "Group Name",
                        value: "groupInfo.name",
                    }, {
                        text: "Start Weight",
                        value: "verifyInfo.startWeight",
                    },
                    {
                        text: "Verify",
                        value: "verify",
                        sortable: false,
                    }, {
                        text: "",
                        value: "data-table-expand"
                    }
                ],
            },
            endWeightTab: {
                open: false,
                expanded: [],
                singleExpand: true,
                title: "End",
                options: {
                    itemsPerPage: 20,
                },
                search: "",
                headers: [{
                        text: "",
                        value: "avatar",
                        sortable: false
                    }, {
                        text: "User Name",
                        value: "name",
                    }, {
                        text: "Group Name",
                        value: "groupInfo.name",
                    }, {
                        text: "End Weight",
                        value: "verifyInfo.endWeight",
                    },
                    {
                        text: "Verify",
                        value: "verify",
                        sortable: false,
                    }, {
                        text: "",
                        value: "data-table-expand"
                    }
                ],
            },
            loading: false,
            groupList: [],
            userList: [],
            challengeInfo: [],

            dialogItem: {
                confirmAction: false,
                confirmText: "Do you want to delete this group?",
                deleteConfirmation: false,
                deletedItemId: null,
            },
            dialogItemDefault: {
                confirmAction: false,
                confirmText: "Do you want to delete this group?",
                deleteConfirmation: false,
                deletedItemId: null,
            }

        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Challenge";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });

        //competition id
        this.id = this.$route.params.id;
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ]),
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin || this.isChallengeAdmin) {
                (async () => {
                    this.loading = true;
                    this.challengeInfo = await getChallengeInfoById(this.id);
                    this.loading = false;
                })();

                (async () => {
                    this.loading = true;
                    this.groupList = await getChallengeGroupListDetails(this.id);
                    this.loading = false;
                })();

                (async () => {
                    this.loading = true;
                    this.userList = await getUserList('verifyByCompetitionId', this.id);
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        setActiveTab(tab) {
            if (tab == 'groupRequestedTab') {
                this.groupRequestedTab.open = true;
                this.startWeightTab.open = false;
                this.endWeightTab.open = false;
            } else if (tab == 'startWeightTab') {
                this.groupRequestedTab.open = false;
                this.startWeightTab.open = true;
                this.endWeightTab.open = false;
            } else if (tab == 'endWeightTab') {
                this.groupRequestedTab.open = false;
                this.startWeightTab.open = false;
                this.endWeightTab.open = true;
            }
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToChallengeList() {
            this.$router.push(`/challenge`);
        },
        goToUserList(item) {
            this.$router.push(`/challenge/${this.id}/${item.id}`);
        },
        dialogDeleteGroup(item) {
            this.dialogItem.deleteConfirmation = true;
            this.dialogItem.deletedItemId = item.id;

            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },
        actionDeleteGroup() {
            (async () => {
                await removeChallengeGroup(this.id, this.dialogItem.deletedItemId);
                this.dialogItem.confirmAction = true;
                this.dialogItem.confirmText = "Done!";
                this.dialogItem.deleteConfirmation = this.dialogItemDefault.deleteConfirmation;
                this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
                await this.initialize();
            })();
        },
        closeConfirmationDialog() {
            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
            this.dialogItem.deleteConfirmation = false;
            this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId;
        },
        actionVerify(item) {
            (async () => {
                if (this.groupRequestedTab.open) {
                    await setGroupInfo(this.id, item.id, {
                        verify: item.verifyInfo.verify,
                        verifyBy: this.loggedInUserId,
                        verifyDate: new Date()
                    });
                } else if (this.startWeightTab.open) {
                    await setUserCompatitionInfo(this.id, item.uid, {
                        startWeightVerify: item.verifyInfo.startWeightVerify,
                        startWeightVerifyBy: this.loggedInUserId,
                        startWeightVerifyDate: new Date()
                    });
                } else if (this.endWeightTab.open) {
                    await setUserCompatitionInfo(this.id, item.uid, {
                        endWeightVerify: item.verifyInfo.endWeightVerify,
                        endWeightVerifyBy: this.loggedInUserId,
                        endWeightVerifyDate: new Date()
                    });
                }
            })();
        },
    },
};
</script>

